import { withAnalyticsTracking } from '@/utilities/analytics/apiAnalytics'
import { errorAnalyticsPayload } from '@/utilities/analytics/errorAnalytics'
import { trackEvent } from '@/utilities/analytics/trackEvent'
import { syncPartnerIdsAction } from '@/services/payload/payloadServerRepository'
import type { SessionJwtFailureReason } from '@/utilities/stytch/constants'

export type PartnerSyncContext = 'existing-user-authentication' | 'new-user-registration'

type SyncPartnerIds = {
  context: PartnerSyncContext
  analyticsProperties?: {
    kitId?: string
  }
}

export async function syncTenantPartnerIds({ context, analyticsProperties }: SyncPartnerIds) {
  const additionalProperties = {
    context,
    ...analyticsProperties,
  }
  let sessionJwtReason: SessionJwtFailureReason | undefined

  try {
    const result = await withAnalyticsTracking(() => syncPartnerIdsAction(), {
      eventName: 'tenant:sync_partner_ids_api',
      additionalProperties,
    })

    if (!result.success) {
      sessionJwtReason = result.sessionJwtReason
      throw new Error('Missing or invalid session')
    }

    if (result.skipped) {
      if (result.skippedReason === 'impersonated') {
        trackEvent('tenant:sync_partner_ids_skip_impersonated', {
          ...additionalProperties,
          gate: 'partner_id_sync',
          source: 'syncPartnerIdsAction',
        })
        return
      }

      trackEvent('tenant:sync_partner_ids_skip_already_exists', additionalProperties)
      return
    }

    trackEvent('tenant:sync_partner_ids_success', additionalProperties)
  } catch (error) {
    trackEvent('tenant:sync_partner_id_fail', {
      ...additionalProperties,
      ...errorAnalyticsPayload(error),
      ...(sessionJwtReason ? { sessionJwtReason } : {}),
    })
  }
}
